import React, { useState } from "react";
import "../index.css";
import FormulaBuilderList from "./FormulaBuilderList";
import FormulaBuilderForm from "./FormulaBuilderForm";

const FormulaBuilderPage: React.FC = () => {
  const [formulaView, setFormulaView] = useState<"list" | "form">("list");
  const [editingFormulaId, setEditingFormulaId] = useState<
    string | undefined
  >();

  return (
    <div className="analyze-container">
      {formulaView === "list" && (
        <FormulaBuilderList
          onAdd={() => {
            setEditingFormulaId(undefined);
            setFormulaView("form");
          }}
          onEdit={(formulaId) => {
            setEditingFormulaId(formulaId);
            setFormulaView("form");
          }}
        />
      )}

      {formulaView === "form" && (
        <FormulaBuilderForm
          formulaId={editingFormulaId}
          onCancel={() => {
            setEditingFormulaId(undefined);
            setFormulaView("list");
          }}
          onSaved={() => {
            setEditingFormulaId(undefined);
            setFormulaView("list");
          }}
        />
      )}
    </div>
  );
};

export default FormulaBuilderPage;
